module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"ticket.field.company":"โดย","ticket.field.report_by":"ผู้แจ้ง : {name}","ticket.field.event_date":"เมื่อ","ticket.field.general_ticket.short":"ทั่วไป","ticket.field.resolved_result.prefix":"ผลวิเคราะห์ : ","ticket.field.status":"สถานะ : {status}"}}')
  delete Component.options._Ctor
}
